import { post, postJson, imagePost, deleteApi, get } from "./axios3";

// 装修保存
export const saveDecoration = (p) => postJson(`/decorationInfo/saveByType`, p);

// 根据类型查新模板详细信息 适用于一个类型只有一个模版
export const getDecorationInfoDetail = (type) =>
  get(`/decorationInfo/detailByType/${type}`, {});

// 中奖名单列表
export const winnerListPage = (p) => postJson(`/winnerList/page`, p);

// 中奖名单人数列表
export const winnerListRecord = (p) => postJson(`/winnerList/record/page`, p);

// 活动列表
export const paradiseAndTaskCommonList = (p) =>
  postJson(`/paradiseAndTaskCommon/list`, p);

// 新增/编辑系统名单
export const winnerListSaveOrEdit = (p) =>
  postJson(`/winnerList/saveOrEdit`, p);

// 导入名单
export const winnerListImport = (url, p) =>
  imagePost(`/winnerList/import${url}`, p);

// 删除系统名单
export const winnerListDelete = (id, p) =>
  deleteApi(`/winnerList/delete/${id}`, p);
